"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = exports.AVATAR_SIZES = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var PlaceholderIcon_1 = require("./PlaceholderIcon");
var Avatar_styles_1 = __importStar(require("./Avatar.styles"));
exports.AVATAR_SIZES = Avatar_styles_1.sizes;
function Avatar(_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'md' : _b, src = _a.src, alt = _a.alt, _c = _a.radius, radius = _c === void 0 ? 'sm' : _c, children = _a.children, _d = _a.color, color = _d === void 0 ? 'gray' : _d, themeOverride = _a.themeOverride, others = __rest(_a, ["className", "size", "src", "alt", "radius", "children", "color", "themeOverride"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var classes = Avatar_styles_1.default({ color: color, radius: radius, size: size, theme: theme });
    var _e = react_1.useState(!src), error = _e[0], setError = _e[1];
    react_1.useEffect(function () {
        !src ? setError(true) : setError(false);
    }, [src]);
    return (react_1.default.createElement("div", __assign({}, others, { "data-mantine-composable": true, className: clsx_1.default(classes.avatar, className) }), error ? (react_1.default.createElement("div", { "data-mantine-placeholder": true, className: classes.placeholder, title: alt }, children || react_1.default.createElement(PlaceholderIcon_1.PlaceholderIcon, { className: classes.placeholderIcon }))) : (react_1.default.createElement("img", { className: classes.image, src: src, alt: alt, onError: function () { return setError(true); } }))));
}
exports.Avatar = Avatar;
Avatar.displayName = '@mantine/core/Avatar';
